<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="titoloForm">
<form #f="ngForm" [formGroup]="titoloForm" (ngSubmit)="update();">
	<div class="row">
		<div comboModInput class="col-sm-6" [labelInput]="'Titolo'"
			formControlName="tipoTitoloEsecutivo" [mandatory]="true"
			[objectReference]="request.tipoTitoloEsecutivo"
			[control]="titoloForm.controls['tipoTitoloEsecutivo']"
			(change)="onChangeTipoTitolo($event)" [ngModel]="request.tipoTitoloEsecutivo"
			(onReturn)="request.tipoTitoloEsecutivo = $event"
			[optionsCombo] ="tipiTitolo"></div>
		<div comboModInput class="col-sm-6" [labelInput]="'Tipo titolo'"
			formControlName="sottoTipoTitoloEsecutivo" [mandatory]="true"
			[objectReference]="request.sottoTipoTitoloEsecutivo"
			[control]="titoloForm.controls['sottoTipoTitoloEsecutivo']"
			(onReturn)="request.sottoTipoTitoloEsecutivo = $event;"
			[optionsCombo] ="sottoTipiTitolo" [ngModel]="request.sottoTipoTitoloEsecutivo"
			(change)="onChangeSottoTipoTitoloEsecutivo($event)"></div>
	</div>
	<div class="row">
		<div textInput [control]="titoloForm.controls['descrizione']"
			class="col-sm-12" [labelInput]="'Descrizione'" [mandatory]="true"
			formControlName="descrizione" [(ngModel)]="request.descrizione"></div>
	</div>
	<div class="row">
		<div naturalNumberInput [control]="titoloForm.controls['numero']"
			class="col-sm-3" [labelInput]="'Numero'" formControlName="numero"
			[(ngModel)]="request.numero"></div>
		<div naturalNumberInput [control]="titoloForm.controls['anno']" [maxLength]="'4'"
			class="col-sm-3" [labelInput]="'Anno'" formControlName="anno" [checkFormat]="true"
			[(ngModel)]="request.anno"></div>
		<div datePickerInput class="col-sm-3"
			[control]="titoloForm.controls['dataIscrizione']"
			[labelInput]="'Data di iscrizione'" formControlName="dataIscrizione"
			[(ngModel)]="request.dataIscrizione"></div>
		<div
			textInputCurrency [control]="titoloForm.controls['valore']"
			class="col-sm-3" [labelInput]="'Valore'"
			formControlName="valore" [location]="'SezioneEconomica'" 
			[(ngModel)]="request.valore"></div>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="request.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'" [disabled]="!titoloForm.valid">
	</div>
</form>
</ng-template>
